import axios from 'axios';
import { BASE_URL } from './constants';

export const getResources = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/resources`, {
        params: {
            language,
            country,
        },
    });
};
